export const Bio = {
  name: "Naveen Kumar",
  roles: [    
    "Java Full Stack Developer",
    "Backend Developer",
    "Programmer",
  ],
  description:
    "I have a proven track record of delivering high-quality solutions, developing new features, optimizing performance, and enhancing product features. With an M.Tech in Software Engineering from VIT, I am passionate about learning new things and applying that knowledge to drive success in my job roles and create innovative solutions. I am actively seeking backend and Java full-stack development roles to leverage my skills and grow professionally.",
  github: "https://github.com/Naveen-131",
  resume:
    "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/docs/NaveenKumar+SDE.pdf",
  linkedin: "https://www.linkedin.com/in/naveenkumar131/",
  instagram: "https://www.instagram.com/n.a.v.e.e.n_sai/",
  email: "naveenmadhavan131@gmail.com",
  twitter:"https://twitter.com/Naveen_sai13",
};

export const skills = [
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://www.vectorlogo.zone/logos/java/java-icon.svg",
      },
      {
        name: "Spring",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Spring Boot",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Spring MVC",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "JPA",
        image: "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      }, 
      {
        name: "Python",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Python.png",
      },
      {
        name: "Oracle SQL",
        image: "https://www.vectorlogo.zone/logos/oracle/oracle-ar21.svg",
      },
      {
        name: "PostgreSQL",
        image:
          "https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg",
      },
      {
        name: "MySQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },   
      {
        name: "MongoDB",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
    
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      }    
    ],
  },
  
  {
    title: "Others",
    skills: [
      {
        name: "Finacle CRM",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Finacle.png",
      },
      {
        name: "Finacle Customization",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Finacle_2.png",
      },
      {
        name: "Rest API",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/restAPI.png",
      },
      {
        name: "Microservices",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/microservices.png",
      },

      {
        name: "TDD",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/TDD.png",
      },
      {
        name: "Unit Testing",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Unit+Testing.png",
      },
      {
        name: "UAT",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/UAT.png",
      },
      {
        name: "XML",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/xml.png",
      },
      {
        name: "JSON",
        image:
        "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/json.png",
      },
      {
        name: "Agile Development",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Agile.png",
      },

    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "Git",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/git.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "JIRA",
        image:
          "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Postman.png",
      },
      {
        name: "Swagger",
        image:
          "https://raw.githubusercontent.com/get-icon/geticon/fc0f660daee147afb4a56c64e12bde6486b73e39/icons/swagger.svg",
      },
      {
        name: "Eclipse",
        image:
          "https://www.vectorlogo.zone/logos/eclipse/eclipse-icon.svg",
      },
      {
        name: "IntelliJ",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/IntelliJ.png",
      },
      {
        name: "Oracle SQL Developer",
        image:
          "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/SQL_developer.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/athenahealth.png", 
    role: "Member of Technical Staff",
    company: "Athenahealth",
    date: "Feb 2024 – present",
    desc: "Developed and implemented a code review lint tool used by multiple teams, reducing code rework by 40% and significantly enhancing productivity. Contributed to the rules migration, migrating Perl code to Java and Spring Boot for claim rules, achieving a 10% performance improvement through code optimization and cleanup. Worked on an AI code generator tool, resulting in a 40% increase in productivity and significantly reducing development time",
    skills: [
      "Java",
      "Spring Boot",
      "Spring MVC",
      "Perl",
      "Python",
      "Code Optimization",
      "Microservices",
      "Unit Testing",
      "Oracle SQL",
      "Performance Tuning",
    ],
    doc: "",
  },
  {
    id: 0,
    img: "https://www.logo.wine/a/logo/Capgemini/Capgemini-Logo.wine.svg",
    role: "Senior Software Engineer ",
    company: "Capgemini.",
    date: "Jan 2023 - Feb 2024",
    desc: "Worked as a backend developer, contributing by creating new functionalities and features. I am proficient in delivering code bug fixes for existing system issues based on business client requirements. Additionally, I have successfully resolved over 6500 account data issues in the production environment",
    skills: [
      "Java",
      "Oracle SQL",
      "XML",
      "SOAP",
      "Finacle CRM",
      "Unit Testing",
      "UAT",
      "Microservices",

    ],
    doc: "",
  },
  {
    id: 0,
    img: "https://www.logo.wine/a/logo/Capgemini/Capgemini-Logo.wine.svg",
    role: "Software Engineer",
    company: "Capgemini",
    date: "July 2021 - Dec 2022",
    desc: "Worked on Finacle Banking Product, as a Java Full Stack Developer, responsible for creating new functionalities and features and proficient in delivering code bug fixes for existing system issues based on business client requirements.",
    skills: [
      "Java",
      "Oracle SQL",
      "Spring Boot",
      "Spring MVC",
      "Finacle CRM",
      "Rest APIs",
      "Microservices",
      "JSON",
      "HTML",
      "CSS",
      "JavaScript",
      "ReactJs",
    ],
   
  },
  {
    id: 1,
    img: "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Crescent_Technosoft.png",
    role: "Web developer Internship",
    company: "Crescent Technosoft",
    date: "May 2019 - July 2019",
    desc: "Acquired knowledge and experience in PHP, HTML, CSS, and Bootstrap, enhancing technical versatility.Collaborated with the team to design and implement login and user modules, enhancing the E-Commerce system's functionality.",
    skills: [
      "HTML",
      "CSS",
      "Javascript",
      "PHP",
      "Bootstrap",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://findlogovector.com/wp-content/uploads/2022/05/vellore-institute-of-technology-vit-logo-vector-2022.png",
    school: "VIT University , Chennai",
    date: "July 2016 - Jun 2021",
    grade: "7.82 CGPA",
    desc: "I completed M.Tech Software Engineering (5 Year Integrated) at VIT University,Chennai. I have taken courses in Data Structures, Algorithms, Object Oriented Programming, Software Architecture and Design, Database Management System (DBMS), Web Technologies, Problem Solving, Project Management, Agile Development, Software Design and Development,Operating Systems, and Computer Networks, among others.",
    degree: "Master of Technology in Software Engineering (Integrated)",
  },
  {
    id: 1,
    img: "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/Vetri_Vikaas.png",
    school: "Vetri Vikaas School, Tamilnadu",
    date: "Apr 2015 - Apr 2016",
    grade: "84.3%",
    desc: "I completed my class 12 high school education at Vetri Vikaas Higher Secondary School, Namakkal, where I studied Science with Computer Science.",
    degree: "HSC(XII), Science with Computer",
  },
  {
    id: 2,
    img: "https://naveen-portfolio.s3.ap-south-1.amazonaws.com/Logo/SFS.png",
    school: "St.Francis Desales Hr Sec School, Tamilnadu",
    date: "Apr 2013 - Apr 2014",
    grade: "90.2%",
    desc: "I completed my class 10 education at St.Francis Desales Matric Higher Secondary School, Vellore",
    degree: "SSLC(X)",
  },
];

